module.exports = __webpack_public_path__ + "img/right-arrow.b26be24c.png";